import mockApi from '../mock-api.json';
import mock from '../mock';

const { tableroAnchoBanda, dashboard, tableroChartsdispositivos, tableroChartsinmuebles, bandwidth, inmuebles, regiones, grupos } =
  mockApi.components.examples;

mock.onGet('/dashboard').reply(() => {
  return [200, dashboard];
});

mock.onGet('/tablero/anchobanda/').reply(() => {
  return [200, tableroAnchoBanda.anchoBanda];
});

mock.onGet('/tablero/chartsdispositivos/').reply(() => {
  return [200, tableroChartsdispositivos.chartsdispositivos];
});

mock.onGet('/tablero/chartsinmuebles/').reply(() => {
  return [200, tableroChartsinmuebles.chartsinmuebles];
});

mock.onGet('/anchodebanda/').reply(() => {
  return [200, bandwidth.value];
});

mock.onGet('/memoria/').reply(() => {
  return [200, bandwidth.value];
});

mock.onGet('/cpu/').reply(() => {
  return [200, bandwidth.value];
});

mock.onGet('/tiempoderespuesta/').reply(() => {
  return [200, bandwidth.value];
});

mock.onGet('/disponibilidad/').reply(() => {
  return [200, bandwidth.value];
});

mock.onGet('/inmuebles/').reply(() => {
  return [200, inmuebles.value];
});

mock.onGet('/grupos/').reply(() => {
  return [200, grupos.value];
});

mock.onGet('/regiones/').reply(() => {
  return [200, regiones.value];
});
